module.exports = __webpack_public_path__ + "media/img/decorations/tools-img-2cdf6efa71e05cac0c5fbc115232cbad.svg";